export default __webpack_public_path__ + "static/media/FullSceneEveningBaked.db836a18.glb";